import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map, Observable } from 'rxjs';

@Pipe({
  name: 'timeRemain',
  pure: true
})
export class TimeRemainPipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  transform(value: any): Observable<any> {
    if (value) {
      return this.translate.get(['AFEWMOMENTSLEFT', 'NOTIMELEFT', 'مانده', 'month', 'week', 'day', 'hour', 'minute', 'second', 'year'])
        .pipe(map((x: any) => {
          if (value.indexOf('T') > -1 && !value.endsWith('Z') && !value.endsWith('z')) value += 'Z';
          const seconds = Math.floor((+new Date(value) - +new Date()) / 1000);
          if (seconds < 29 && seconds > 0)
            return x['AFEWMOMENTSLEFT'];

          if (seconds <= 0) return x['NOTIMELEFT'];
          const intervals = {
            // 'year': 31536000,
            // 'month': 2592000,
            // 'week': 604800,
            'day': 86400,
            'hour': 3600,
            'minute': 60,
            'second': 1
          };
          let counter;
          for (let [key, value] of Object.entries(intervals)) {
            counter = Math.ceil(seconds / value);
            if (counter > 1)
              return `${counter} ${x[key]} ${x['مانده']}`;
          }
          return '';
        }))
    }
    return value;
  }
}
